module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.ContainerNoFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.EnqNoFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.contTypeFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.clientIDFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.PODIDFilter ||
        _vm.Filter.TerritoryFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.slineIDFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.billStatusFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.ContainerNoFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.EnqNoFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.contTypeFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.clientIDFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.PODIDFilter ||
    _vm.Filter.TerritoryFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.slineIDFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.billStatusFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getRolloverContList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getRolloverContList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Billing Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.billStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "billStatusFilter", $$v)
      },
      expression: "Filter.billStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Client Name Filter",
      "id": "clientFilter",
      "name": "clientFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job No Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container No Filter",
      "id": "ContainerNoFilter",
      "name": "ContainerNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ContainerNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerNoFilter", $$v)
      },
      expression: "Filter.ContainerNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Enq No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enq No Filter",
      "id": "EnqNoFilter",
      "name": "EnqNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.EnqNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "EnqNoFilter", $$v)
      },
      expression: "Filter.EnqNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Container Type ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "id": "contTypeFilter",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.contTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "contTypeFilter", $$v)
      },
      expression: "Filter.contTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Territory")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllENQTERIOTRYDDList'],
      "option-value": "text",
      "option-text": "text",
      "placeholder": "Select Territory"
    },
    on: {
      "input": function($event) {
        _vm.getPODLIST(_vm.Filter.TerritoryFilter);
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1');
      }
    },
    model: {
      value: (_vm.Filter.TerritoryFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TerritoryFilter", $$v)
      },
      expression: "Filter.TerritoryFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getPortDischargeList.length > 0 ?
        _vm.getPortDischargeList :
        _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Sea_Port_NonIndia',
          'getPortDischargeList'
        );
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1');
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.Filter.PODIDFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODIDFilter", $$v)
      },
      expression: "Filter.PODIDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Final Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD');
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1');
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineIDFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineIDFilter", $$v)
      },
      expression: "Filter.slineIDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Client Name ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientIDFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientIDFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIDFilter", $$v)
      },
      expression: "Filter.clientIDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getRolloverContTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getRolloverContList,
      "fields": _vm.ContainerFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "containerNo",
      fn: function(row1) {
        return [_c('span', {
          staticStyle: {
            "color": "blue",
            "font-weight": "bold"
          },
          on: {
            "click": function($event) {
              _vm.getShipmentSubscription(row1.item)
            }
          }
        }, [_vm._v("Container No : "), _c('u', [_vm._v(_vm._s(row1.item.containerNo))])]), _c('br'), _vm._v(" "), _c('span', {
          style: (row1.item.subscription_id ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row1.item.subscription_id ? _vm.goToSubscriptionPage(row1.item) : ''
            }
          }
        }, [_vm._v("Booking No : "), _c('u', [_vm._v(_vm._s(row1.item.booking_number))])]), _c('br'), _vm._v(" "), _c('span', {
          style: (row1.item.subscription_id ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row1.item.allModuleId ? _vm.goExportFCLPage(row1.item) : ''
            }
          }
        }, [_vm._v("Job No : "), _c('u', [_vm._v(_vm._s(row1.item.JobNo))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Job Type : " + _vm._s(row1.item.JobType))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Job Date : " + _vm._s(row1.item.JobDate))]), _c('br'), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": row1.item.JobDate,
            "assign_job_type": row1.item.JobType,
            "assign_raised_from": 'Raised From: ',
            "assign_raised_by": 'Raised By: ' + row1.item.raisedBy,
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.JobNo,
            "fk_client_id": '',
            "fk_pod_id": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "GRNSeries",
      fn: function(row2) {
        return [_c('span', [_vm._v("GRN No : " + _vm._s(row2.item.GRNSeries))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("GRN Date : " + _vm._s(row2.item.GRNDATE))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Client : " + _vm._s(row2.item.clientName))])]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Sline : " + _vm._s(row2.item.shippingLine))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("POR : " + _vm._s(row2.item.POR))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("POL : " + _vm._s(row2.item.POL))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("POD : " + _vm._s(row2.item.POD))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("FPOD : " + _vm._s(row2.item.FPOD))])]
      }
    }, {
      key: "INVNO",
      fn: function(row2) {
        return [_c('span', [_vm._v("Inv No : " + _vm._s(row2.item.INVNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv Date : " + _vm._s(row2.item.INVDATE))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("BOE No : " + _vm._s(row2.item.BOENO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("BOE Date : " + _vm._s(row2.item.BOEDATE))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Line Seal : " + _vm._s(row2.item.LineSealNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Custom Seal : " + _vm._s(row2.item.customSealNo))]), _c('br')]
      }
    }, {
      key: "netWeight",
      fn: function(row2) {
        return [_c('span', [_vm._v("Net Weight : " + _vm._s(row2.item.netWeight))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Gross Weight : " + _vm._s(row2.item.grossWeight))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Tare Weight : " + _vm._s(row2.item.tareWeight))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Unit : " + _vm._s(row2.item.weightUnit))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Measurement : " + _vm._s(row2.item.measurement))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Package : " + _vm._s(row2.item.packageName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("No.of Package : " + _vm._s(row2.item.noOfpkgUnit))]), _c('br')]
      }
    }, {
      key: "raisedBy",
      fn: function(row3) {
        return [(row3.item.raisedBy) ? _c('span', [_vm._v("Raised By : " + _vm._s(row3.item.raisedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.create_date) ? _c('span', [_vm._v("Created Date : " + _vm._s(row3.item.create_date)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updatedBy) ? _c('span', [_vm._v("Updated By : " + _vm._s(row3.item.updatedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.update_date) ? _c('span', [_vm._v("Updated Date : " + _vm._s(row3.item.update_date)), _c('br')]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b259ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ocean-insights/RolloverList.vue
// module id = 2646
// module chunks = 0